// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2ul4W","fileBtn":"File_fileBtn__Q-Klf","closeBtn":"File_closeBtn__X5ArT","fileSelected":"File_fileSelected__1WLI1","disabled":"File_disabled__21rqa"};